// extracted by mini-css-extract-plugin
module.exports = {"baseColor":"var(--base-color)","baseColorLight":"var(--base-color-light)","baseBgColor":"var(--base-bg-color)"};